export type NavGroup = 'Ops' | 'Collections' | 'Reports' | 'Tools' | 'System';

export interface AdminNavItem {
  id: string;
  label: string;
  iconName: string;
  color: string;
  subLabel: string;
  group?: NavGroup;
}

export const ADMIN_NAV_ITEMS: AdminNavItem[] = [
  { id: '/admin/dashboard', label: 'Dashboard', iconName: 'Analytics', color: '#0F766E', subLabel: 'Business Overview', group: 'Ops' },
  { id: '/admin/customers', label: 'Customers', iconName: 'People', color: '#0F766E', subLabel: 'Manage Clients', group: 'Ops' },
  { id: '/admin/payments', label: 'Payments', iconName: 'Payment', color: '#0F766E', subLabel: 'All Payments & Debits', group: 'Ops' },
  { id: '/admin/leads', label: 'Leads', iconName: 'ContactMail', color: '#0F766E', subLabel: 'Loan Applications', group: 'Ops' },
  { id: '/admin/products', label: 'Products', iconName: 'Inventory', color: '#0F766E', subLabel: 'Manage Products', group: 'Ops' },

  { id: '/admin/blacklisted-customers', label: 'Blacklisted', iconName: 'Block', color: '#B91C1C', subLabel: 'Written-off / blocked borrowers', group: 'Collections' },
  { id: '/admin/eligibility-check', label: 'Eligibility', iconName: 'FactCheck', color: '#0369A1', subLabel: 'Blocklist check by email / mobile', group: 'Collections' },
  { id: '/admin/deposits-monitoring', label: 'Deposits', iconName: 'Savings', color: '#0F766E', subLabel: 'Report & audit trail', group: 'Collections' },
  { id: '/admin/whatsapp-payment-reminders', label: 'WA Reminders', iconName: 'WhatsApp', color: '#15803D', subLabel: 'Approve & send payment reminders', group: 'Collections' },
  { id: '/admin/interest-requests', label: 'Interest Requests', iconName: 'Favorite', color: '#D97706', subLabel: 'Customer Interests', group: 'Collections' },

  { id: '/admin/monthly-payment-transactions', label: 'Monthly Txn Summary', iconName: 'CalendarMonth', color: '#475569', subLabel: 'Transactions by month (till today)', group: 'Reports' },
  { id: '/admin/customer-lending-audit', label: 'Lending audit', iconName: 'Assessment', color: '#475569', subLabel: 'INTEREST vs short-term, expected interest', group: 'Reports' },
  { id: '/admin/capital-efficiency', label: 'Capital efficiency', iconName: 'Speed', color: '#15803D', subLabel: 'CE% ranking & allocation suggestions', group: 'Reports' },
  { id: '/admin/monthly-capital-efficiency', label: 'Monthly CE (MCE)', iconName: 'Timeline', color: '#0F766E', subLabel: 'Monthly snapshots, trends & flags', group: 'Reports' },
  { id: '/admin/financial-summary', label: 'Financial Summary', iconName: 'AccountBalance', color: '#0F766E', subLabel: 'Annual Revenue & Balance Sheet', group: 'Reports' },
  { id: '/admin/monthly-kpi-snapshots', label: 'Monthly KPIs', iconName: 'ShowChart', color: '#0369A1', subLabel: 'Month-end snapshots & trends', group: 'Reports' },
  { id: '/admin/revenue-cashflow', label: 'Revenue by Customer', iconName: 'Receipt', color: '#D97706', subLabel: 'Revenue & Cashflow Report', group: 'Reports' },
  { id: '/admin/interest-collected-month', label: 'Interest This Month', iconName: 'TrendingUp', color: '#0F766E', subLabel: 'Interest by Customer (till today)', group: 'Reports' },
  { id: '/admin/oflync-cashflow', label: 'Oflync cashflow', iconName: 'CloudSync', color: '#0369A1', subLabel: 'Monthly Oflync connector log', group: 'Reports' },

  { id: '/admin/networth', label: 'Net worth', iconName: 'AccountBalanceWallet', color: '#475569', subLabel: 'Personal assets & snapshots', group: 'Tools' },

  { id: '/admin/settings', label: 'Settings', iconName: 'Settings', color: '#64748B', subLabel: 'Account Settings', group: 'System' },
];

export function groupedNavItems(): { group: NavGroup; items: AdminNavItem[] }[] {
  const order: NavGroup[] = ['Ops', 'Collections', 'Reports', 'Tools', 'System'];
  return order
    .map((group) => ({
      group,
      items: ADMIN_NAV_ITEMS.filter((i) => (i.group ?? 'Ops') === group),
    }))
    .filter((g) => g.items.length > 0);
}
